enum RendererTypesEnum {
	RADIO = "RadioType",
	CHECKBOX = "CheckboxType",
	SWATCH_COLOR = "SwatchColorType",
	YES_NO = "YesNoType",
	DEFAULT = "CheckboxType",
}

export default RendererTypesEnum;
